// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
  width: 100%;
}

.mat-mdc-radio-button {
  margin: 0 12px;
}

form {
  width: 100%;
}

.formRow {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.formCol {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  padding-right: 20px;
}

.formCol:last-child {
  padding-right: 0px;
}

.first-field {
  margin-top: 15px;
}

.radio-group-field {
  height: 35px;
}
.radio-group-field label {
  color: gray;
  font-size: 12px;
}

#image-input {
  display: none;
}

.file-upload {
  width: 180px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.file-upload mat-icon {
  margin-left: -23px;
  font-size: 54px;
  position: absolute;
  top: 138px;
  color: white;
}

.fixActionRow {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex-grow: 1;
}

::ng-deep mat-tab-group .mat-mdc-tab-header {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1000;
  background: white;
}

.toggle {
  padding-bottom: 10px;
  margin-top: 15px;
}

.bt-spinner {
  display: inline;
  padding-right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dialogs/userdialog/user-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EAEA,mBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,YAAA;AADF;AAGE;EACE,WAAA;EACA,eAAA;AADJ;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAFF;AAKI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAHN;;AAQA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAUE;EACE,gBAAA;EACA,wBAAA;EACA,MAAA;EACA,aAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,oBAAA;EACA,gBAAA;AARF;;AAWA;EACE,eAAA;EACA,mBAAA;AARF","sourcesContent":["mat-form-field {\n  width: 100%;\n}\n\n.mat-mdc-radio-button {\n  margin: 0 12px;\n}\n\nform {\n  width: 100%;\n}\n\n.formRow {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.formCol {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0;\n  //   max-width:300px;\n  padding-right: 20px;\n}\n\n.formCol:last-child {\n  padding-right: 0px;\n}\n\n\n.first-field {\n  margin-top: 15px;\n}\n\n.radio-group-field {\n  height: 35px;\n\n  label {\n    color: gray;\n    font-size: 12px;\n  }\n}\n\n#image-input {\n  display: none;\n}\n\n.file-upload {\n  width:180px;\n  margin-top: 20px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n\n  \n    mat-icon {\n      margin-left: -23px;\n      font-size: 54px;\n      position: absolute;\n      top: 138px;\n      color: white;\n    }\n  \n}\n\n.fixActionRow {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.spacer {\n  flex-grow: 1;\n}\n\n::ng-deep mat-tab-group {\n  // sticky tab header\n  .mat-mdc-tab-header {\n    position: sticky;\n    position: -webkit-sticky;\n    top: 0;\n    z-index: 1000;\n    background: white;\n  }\n}\n\n.toggle{\n  padding-bottom: 10px;\n  margin-top: 15px;\n}\n\n.bt-spinner {\n  display: inline;\n  padding-right: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
